module.exports = __webpack_public_path__ + "img/tzsb.97f2296d.png";